/**
 * Brands Carousel - Minimal JS for Shopify theme editor events
 * The infinite scroll is handled entirely by CSS animation.
 * JS only handles editor reloads and accessibility.
 */
(function () {
  'use strict';

  /**
   * Restart the CSS animation when the section is re-rendered
   * in the Shopify theme editor to avoid visual glitches.
   */
  function initCarousel(section) {
    var track = section.querySelector('[data-brands-track]');
    if (!track || track.children.length === 0) return;

    // Read speed from section data attribute and apply to CSS var
    var speed = section.getAttribute('data-scroll-speed') || '30';
    track.style.setProperty('--scroll-speed', speed + 's');
  }

  // Init all carousels on page
  document.querySelectorAll('[data-brands-carousel]').forEach(initCarousel);

  // Shopify theme editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-brands-carousel]');
      if (section) initCarousel(section);
    });
  }
})();
